module.exports = __webpack_public_path__ + "static/img/italogo.b5f48c2f.png";